import { DataTable } from "@msuite/ui/table";
import { useTeams } from "@/hooks/use-teams";
import { OrganizationSettingsTeamsMenu } from "@/sites/organization/settings/organization-settings-teams/organization-settings-teams-menu";
import { columns } from "./table-config";
import { TeamGroupHeader } from "./team-group-header";

export function OrganizationSettingsTeams() {
	/** Hooks */
	const { teams, isLoading, queryKey, refetch } = useTeams();

	/** Render */
	return (
		<DataTable
			data={teams}
			columns={columns}
			isLoading={isLoading}
			refetch={refetch}
			queryKey={queryKey}
			menu={() => <OrganizationSettingsTeamsMenu />}
			persistenceKey="organization-teams-table"
			grouping={["teamId"]}
			initialColumnVisibility={{ teamId: false, teamName: false }}
			renderGroupHeader={(item) => <TeamGroupHeader item={item} />}
		/>
	);
}
